import type { SocialPost } from '@/lib/social-api';

function num(value: unknown): number {
  const n = typeof value === 'number' ? value : Number.parseFloat(String(value ?? ''));
  return Number.isFinite(n) ? n : 0;
}

export function postMetrics(post: SocialPost): { impressions: number; engagement: number } | null {
  const published = post.targets.filter((t) => t.status === 'published');
  if (!published.length) return null;
  let impressions = 0;
  let engagement = 0;
  let has = false;
  for (const t of published) {
    const a = t.analytics ?? {};
    const imp = num(a.impressions) || num(a.reach) || num(a.views);
    const eng = num(a.likes) + num(a.comments) + num(a.shares) + num(a.clicks);
    if (imp || eng) has = true;
    impressions += imp;
    engagement += eng;
  }
  return has ? { impressions, engagement } : null;
}

export function formatMetric(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)} Mio`;
  if (n >= 1000) return `${(n / 1000).toFixed(n >= 10_000 ? 0 : 1)}k`;
  return String(Math.round(n));
}
